import {
    uploadImages,
    uploadDocument,
    uploadImage,
} from '../../components/api/api';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {
    fetchedElements,
    gotPage,
    addApiCallInProgress,
    removeApiCallInProgress,
    invalidateUrl,
    updatedPage,
    validatedUrl,
    fetchedFormTypes,
    fetchedPageVersions,
    fetchedPageVersion,
    deletedPageVersion,
    updatedPageVersion,
    setBgColors,
} from './actions';
import {ROOT_URL} from '../../config';
import {gotBlocksByTerms} from '../blocks/actions';
import {gotReviewsBySearchTerms} from '../reviews/actions';
import {gotFaqsBySearchTerms} from '../faqs/actions';
import {BLOCK_SEARCH_BY_TITLE} from '../blocks/types';
import {REVIEW_SEARCH_BY_AUTHOR} from '../reviews/types';
import {FAQ_SEARCH_BY} from '../faqs/types';
import _findIndex from 'lodash/findIndex';
import update from 'immutability-helper';
import {hasTheNecessaryLenghtForAjaxCall} from '../../components/helpers/helpers';

export function getPage(id) {
    return (dispatch, getState) => {
        let state = getState();

        // Check if the data for the page already exists, and if it does stop the api call
        let exists = state.pageBuilder.pages[id];
        if (exists) {
            return;
        }

        let options = {
            url: `${ROOT_URL}/page/${id}`,
            method: 'GET',
        };

        // Check if api call is in progress, mark it as in progress if it is not already
        // stop the call if it is.
        // This is done as sometimes an api call is initiated while another one is already in progress before it can finish,
        // and this prevents making an aditional useless call.
        let inProgress =
            state.pageBuilder.apiCallsInProgress.indexOf(options.url) !== -1;
        if (inProgress) {
            return;
        }

        dispatch(addApiCallInProgress(options.url));

        return request(options, dispatch).then((response) => {
            dispatch(gotPage(response));
            dispatch(removeApiCallInProgress(options.url));
        });
    };
}

export function searchBlocksByTermsOfPage(pageId) {
    return (dispatch, getState) => {
        let state = getState();
        let exists = state.blocks.allByTermsPageId === pageId;

        if (exists) {
            return;
        }

        let options = {
            url: `${ROOT_URL}/blocks-by-terms/${pageId}`,
            method: 'GET',
        };

        // Check if api call is in progress, mark it as in progress if it is not already
        // stop the call if it is.
        // This is done as sometimes an api call is initiated while another one is already in progress before it can finish,
        // and this prevents making an aditional useless call.
        let inProgress =
            state.pageBuilder.apiCallsInProgress.indexOf(options.url) !== -1;

        if (inProgress) {
            return;
        }

        dispatch(addApiCallInProgress(options.url));

        return request(options, dispatch).then((response) => {
            dispatch(gotBlocksByTerms(response.data, pageId));
            dispatch(removeApiCallInProgress(options.url));
        });
    };
}

export function onSearchBlocks(searchBy, pageId) {
    return (dispatch) => {
        return new Promise(resolve => {
            dispatch({
                type: BLOCK_SEARCH_BY_TITLE,
                payload: {
                    searchBy,
                    pageId,
                },
            });
            resolve();
        }).then(() => {
            dispatch(debouncedSearchBlocks(searchBy, pageId));
        });
    };
}

export function debouncedSearchBlocks(searchBy, pageId) {
    const thunk = (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks-by-terms/${pageId}?searchBy=${encodeURIComponent(
                searchBy
            )}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) => {
            dispatch(gotBlocksByTerms(response.data));
        });
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'TRACK_CUSTOMER_SEARCH',
        },
    };

    return thunk;
}

export function onSearchReviews(searchBy, pageId) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: REVIEW_SEARCH_BY_AUTHOR,
                payload: {
                    searchBy,
                    pageId,
                },
            });
            resolve();
        }).then(() => {
            dispatch(debouncedSearchReviews(searchBy, pageId));
        });
    };
}

export function debouncedSearchReviews(searchBy, pageId) {
    const thunk = (dispatch) => {
        let options = {
            url: `${ROOT_URL}/reviews?pageId=${pageId}&searchBy=${encodeURIComponent(
                searchBy
            )}`,
            method: 'GET',
        };

        if (hasTheNecessaryLenghtForAjaxCall(searchBy)) {
            return request(options, dispatch).then((response) => {
                dispatch(gotReviewsBySearchTerms(response.data));
            });
        } else {
            return dispatch(gotReviewsBySearchTerms([]));
        }
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'TRACK_CUSTOMER_SEARCH',
        },
    };

    return thunk;
}

export function onSearchFaqs(searchBy, pageId, siteId) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: FAQ_SEARCH_BY,
                payload: {
                    searchBy,
                    pageId,
                    siteId,
                },
            });
            resolve();
        }).then(() => {
            dispatch(debouncedSearchFaqs(searchBy, pageId, siteId));
        });
    };
}

export function debouncedSearchFaqs(searchBy, pageId, siteId) {
    const thunk = (dispatch) => {
        let options = {
            url: `${ROOT_URL}/faqs?page_id=${pageId}&site_id=${siteId}&searchBy=${encodeURIComponent(
                searchBy
            )}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) => {
            dispatch(gotFaqsBySearchTerms(response.data));
        });
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'TRACK_CUSTOMER_SEARCH',
        },
    };

    return thunk;
}

export function fetchElements(pageId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/elements/${pageId}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(fetchedElements(response.data))
        );
    };
}

export function savePage(id, sections, page, preview) {
    return (dispatch) => {
        let images = [];
        let docs = [];
        let heroImage = [];
        let prefix = 'product';
        let prefixReview = 'review';
        let itinerarySectionId = null;

        sections.forEach((section, sectionIndex) => {
            if (section.data) {
                // Fixes case where page has not yet been created and id = null.
                // Id then resolved in backend using uniqueid when id is null
                let section_id = section.id;

                if (section.id === null) {
                    section_id = section.uniqueId;
                }

                if (section.data.images) {
                    section.data.images.forEach((image, index) => {
                        if (image.new && !image.deleted) {
                            images[section_id + '_' + index] = {
                                section_id: section.id,
                                section_index: sectionIndex,
                                index: index,
                                image: image,
                                code: null,
                            };
                        }
                    });
                }

                // Handle any images for large snippets section
                if (section.data.large_snippets) {
                    section.data.large_snippets.forEach(
                        (large_snippet, index) => {
                            if (
                                large_snippet.snippet_image &&
                                large_snippet.snippet_image.new &&
                                !large_snippet.snippet_image.deleted
                            ) {
                                images[
                                    section_id + '_' + index + '_snippet'
                                ] = {
                                    section_id: section.id,
                                    section_index: sectionIndex,
                                    index: index,
                                    image: large_snippet.snippet_image,
                                    code: null,
                                };
                            }

                            if (
                                large_snippet.logo_image &&
                                large_snippet.logo_image.new &&
                                !large_snippet.logo_image.deleted
                            ) {
                                images[section.id + '_' + index + '_logo'] = {
                                    section_id: section.id,
                                    section_index: sectionIndex,
                                    index: index,
                                    image: large_snippet.logo_image,
                                    code: null,
                                };
                            }
                        }
                    );
                }

                // Handle any images for value proposition section
                if (section.data.value_propositions) {
                    section.data.value_propositions.forEach(
                        (value_proposition, index) => {
                            if (
                                value_proposition.image &&
                                value_proposition.image.new &&
                                !value_proposition.image.deleted
                            ) {
                                images[section_id + '_' + index] = {
                                    section_id: section.id,
                                    section_index: sectionIndex,
                                    index: index,
                                    image: value_proposition.image,
                                    code: null,
                                };
                            }
                        }
                    );
                }

                // Handle any images for promotional boxes section
                if (section.data.promotional_boxes) {
                    section.data.promotional_boxes.forEach(
                        (promotional_box, index) => {
                            if (
                                promotional_box.image &&
                                promotional_box.image.new &&
                                !promotional_box.image.deleted
                            ) {
                                images[section_id + '_' + index] = {
                                    section_id: section.id,
                                    section_index: sectionIndex,
                                    index: index,
                                    image: promotional_box.image,
                                    code: null,
                                };
                            }
                        }
                    );
                }

                // Handle any images for text columns multiple media section
                if (section.data.text_columns_multiple_media) {
                    section.data.text_columns_multiple_media.forEach(
                        (text_columns_single_media_item, index) => {
                            if (
                                text_columns_single_media_item.image &&
                                text_columns_single_media_item.image.new &&
                                !text_columns_single_media_item.image.deleted
                            ) {
                                images[section_id + '_' + index] = {
                                    section_id: section.id,
                                    section_index: sectionIndex,
                                    index,
                                    image: text_columns_single_media_item.image,
                                    code: null,
                                };
                            }
                        }
                    );
                }

                // Handle any section that only take in on image (e.g Group Trips Banner)
                if (section.data.image) {
                    let image = section.data.image;

                    if (image && image.new && !image.deleted) {
                        images[section_id + '_' + 0] = {
                            section_id: section.id,
                            section_index: sectionIndex,
                            index: 0,
                            image: image,
                            code: null,
                        };
                    }
                }
            }

            if (section.data && section.data.itineraries) {
                itinerarySectionId = section.id;

                section.data.itineraries.forEach((document, index) => {
                    if (document && document.new) {
                        docs[itinerarySectionId + '_' + index] = {
                            section_id: section.id,
                            section_index: sectionIndex,
                            index: index,
                            document: document,
                            code: null,
                        };
                    }
                });
            }
        });

        if (page.heroImage) {
            if (page.heroImage.new && !page.heroImage.deleted) {
                heroImage = [
                    {
                        image: page.heroImage,
                    },
                ];
            }
        }

        let reviewImage = null;

        if (page.review && page.review.image) {
            if (page.review.image.new && !page.review.image.deleted) {
                reviewImage = {
                    image: page.review.image,
                };
            }
        }

        uploadImage(
            dispatch,
            reviewImage,
            prefixReview,
            page.site_id,
            (response) => {
                let reviewImageCode = null;

                if (response.data && response.data.code) {
                    if (response.data.code.length) {
                        reviewImageCode = response.data;
                    }
                }

                uploadDocument(
                    dispatch,
                    docs,
                    page.site_id,
                    (response) => {
                        let documentsCodes = null;

                        if (response.data && response.data.documents_codes) {
                            if (response.data.documents_codes.length) {
                                documentsCodes = response.data.documents_codes;

                                if (itinerarySectionId) {
                                    let toEditSectionPosition = _findIndex(
                                        sections,
                                        {id: itinerarySectionId}
                                    );
                                    let toEditSection =
                                        sections[toEditSectionPosition];

                                    toEditSection.data.itineraries =
                                        toEditSection.data.itineraries;
                                    toEditSection.data.documents = documentsCodes;
                                    sections = update(sections, {
                                        [toEditSectionPosition]: {
                                            $set: toEditSection,
                                        },
                                    });
                                }
                            }
                        }

                        uploadImages(
                            dispatch,
                            heroImage,
                            prefix,
                            page.site_id,
                            (response) => {
                                let heroCode = null;

                                if (
                                    response.data &&
                                    response.data.images_codes
                                ) {
                                    if (response.data.images_codes.length) {
                                        heroCode =
                                            response.data.images_codes[0];
                                    }
                                }

                                uploadImages(
                                    dispatch,
                                    images,
                                    prefix,
                                    page.site_id,
                                    (response) => {
                                        let codes = null;

                                        if (
                                            response.data &&
                                            response.data.images_codes
                                        ) {
                                            if (
                                                response.data.images_codes
                                                    .length
                                            ) {
                                                codes =
                                                    response.data.images_codes;
                                            }
                                        }

                                        let options = {
                                            url: `${ROOT_URL}/page/${id}`,
                                            method: 'PUT',
                                            async: false,
                                            data: {
                                                sections: sections,
                                                page: {
                                                    ...page,
                                                    preview: preview,
                                                },
                                                codes: codes,
                                                hero_image_code: heroCode,
                                                review_image_code: reviewImageCode,
                                            },
                                        };

                                        return request(options, dispatch)
                                            .then((response) =>
                                                response.data.preview_url
                                                    ? window.open(
                                                          response.data
                                                              .preview_url
                                                      )
                                                    : dispatch(
                                                          updatedPage(
                                                              id,
                                                              response.data
                                                          )
                                                      )
                                            )
                                            .then(() =>
                                                !preview
                                                    ? toastr.success(
                                                          'Success!',
                                                          'Page ' +
                                                              (page.title !==
                                                              null
                                                                  ? page.title
                                                                  : '') +
                                                              ' has been updated!'
                                                      )
                                                    : false
                                            );
                                    },
                                    (err) => {
                                        console.log(err);
                                    }
                                );
                            },
                            (err) => {
                                console.log(err);
                            }
                        );
                    },
                    (err) => {
                        console.log(err);
                    }
                );
            },
            (err) => {
                console.log(err);
            }
        );
    };
}

export function validateUrl(url, pageId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/validate-url?url=${encodeURIComponent(
                url
            )}&page_id=${pageId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) => {
            if (response.data.valid) {
                dispatch(validatedUrl(url, pageId));
            } else {
                dispatch(invalidateUrl(url, pageId));
            }
        });
    };
}

export function fetchFormTypes(pageId, siteId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/forms?pageId=${pageId}&siteId=${siteId}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) => {
            dispatch(fetchedFormTypes(response.data));
        });
    };
}

export function fetchPageVersions(pageId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/page-versions?pageId=${pageId}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(fetchedPageVersions(response.data))
        );
    };
}

export function fetchPageVersion(versionId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/page-versions/${versionId}`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(fetchedPageVersion(response.data))
        );
    };
}

export function deletePageVersion(versionId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/page-versions/${versionId}`,
            method: 'DELETE',
        };

        return request(options, dispatch)
            .then((response) => dispatch(deletedPageVersion(versionId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Version ' + versionId + ' has been deleted.'
                )
            );
    };
}

export function updatePageVersion(pageVersion, pageId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/page-versions/${pageVersion.id}`,
            method: 'PUT',
        };

        return request(options, dispatch)
            .then((response) => dispatch(updatedPageVersion(pageVersion)))
            .then((response) => dispatch(fetchPageVersions(pageId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Version ' +
                        pageVersion.version +
                        ' has been set as current active version on the website! The page will now reload in order for the changes to take effect!'
                )
            )
            .then(() => setTimeout(() => window.location.reload(true), 2500));
    };
}

export function fetchBgColors() {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/section-backgrounds`,
            method: 'GET',
        };

        return request(options, dispatch).then((response) =>
            dispatch(setBgColors(response.data))
        );
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/thunks.js